import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { Table } from "react-bootstrap";
import { injectModels } from "../../../redux/injectModels";
import { AuthService, EventService } from "../../../services";
import { RatingReviewService } from "../../../services";
import { toast } from "react-toastify";
import {
  formatDateENGB,
  handleConsoleError,
} from "../../../utils/common-methods";
import AutoCompleteDropdown from "../../../components/Common/AutoCompleteDropdown";

const FeedBackReport = (props) => {
  const [currentPage, setCurrentPage] = useState(0);
  const loginUser = AuthService.getLoginUser();
  const [filteredData, setFilteredData] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [eventSearchName, setEventSearchName] = useState("All");

  const rowsPerPage = 10;
  const offset = currentPage * rowsPerPage;
  const paginatedData = filteredData?.slice(offset, offset + rowsPerPage);

  useEffect(() => {
    const bootstrapAsync = async () => {
      await getEventData();
      await getData("All");
    };
    bootstrapAsync();
  }, []);

  const getEventData = async () => {
    try {
      if (loginUser) {
        props.application.setLoading(true);
        const res = await EventService.getEventsByTraderId(loginUser?.id);
        if (res?.isSuccess && res?.data?.length > 0) {
          const eventList = res?.data?.map((item) => ({
            eventName: item?.eventName,
            id: item?.id,
          }));
          setEventList(eventList);
          setSuggestions(eventList.map((item) => item.eventName));
        }
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  // Feedback Report List
  const getData = async (eventid) => {
    const userId = loginUser?.id;
    props.application.setLoading(true);
    let eventId = "00000000-0000-0000-0000-000000000000";
    if (eventid && eventid.length > 5) {
      eventId = eventid;
    }
    try {
      const res = await RatingReviewService.getTraderReviewsReport(
        userId,
        eventId
      );
      if (res?.isSuccess) {
        setFilteredData(res?.data);
        props.application.setLoading(false);
      } else {
        //toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const handleSelect = async (selected) => {
    if (selected && selected.length >= 2) {
      setEventSearchName(selected);
      const filetEvent = eventList.filter(
        (item) => item.eventName?.trim() === selected?.trim()
      );
      if (filetEvent.length > 0) {
        await getData(filetEvent[0]?.id);
      }
    } else {
      setEventSearchName("All");
      await getData("All");
    }
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData?.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={5}
          marginPagesDisplayed={2}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  return (
    <React.Fragment>
      <section>
        <section className="subscription-banner p-0">
          <div className="container">
            <h3>Scores on the Floors</h3>
          </div>
        </section>

        <section className="edit-form-table">
          <div className="container">
            <div className="mb-3">
              <div className="row">
                <div className="col-sm-12">
                  <span>Please enter event name</span>
                  <AutoCompleteDropdown
                    suggestions={suggestions}
                    onSelect={handleSelect}
                  />
                </div>
              </div>
            </div>
            {eventSearchName && (
              <React.Fragment>
                <div className="table-responsive">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>S.No.</th>

                        <th>Event Organizer</th>
                        <th>Message</th>
                        <th>Rating</th>
                        <th>Created On</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedData && paginatedData?.length > 0 ? (
                        <React.Fragment>
                          {paginatedData.map((item, idx) => {
                            return (
                              <tr key={idx}>
                                <td>{calculateSNo(idx)}</td>

                                <td>{item?.fromUser?.businessName}</td>
                                <td>{item?.message}</td>
                                <td>{item?.rating}</td>
                                <td>{formatDateENGB(item?.createdOn)}</td>
                              </tr>
                            );
                          })}
                        </React.Fragment>
                      ) : (
                        <tr>
                          <td colSpan="10 mt-2">No results found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                <div className="table-footer">
                  <p className="mb-3">
                    <strong>Total Count: {filteredData?.length}</strong>
                  </p>
                  {filteredData?.length === 0 ? "" : renderPagination()}
                </div>
              </React.Fragment>
            )}
            {!eventSearchName && (
              <p>Find the feed back by entering the event name.</p>
            )}
          </div>
        </section>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(FeedBackReport);
